import React, { createContext, type PropsWithChildren } from 'react';

import type {
	ChoreographerAssetsContext,
	ChoreographerAssetsContextProviderProps,
} from './__types__/ChoreographerAssetsContext.ts';
import { useChoreographerServices } from './useChoreographerServices.ts';

const Context = createContext<ChoreographerAssetsContext | undefined>(undefined);
const { Consumer, Provider } = Context;

export const ChoreographerAssetsContextProvider = ({
	children,
}: PropsWithChildren<ChoreographerAssetsContextProviderProps>): React.JSX.Element => {
	const choreographerFactoryAssets = useChoreographerServices();

	return <Provider value={choreographerFactoryAssets}>{children}</Provider>;
};

export { Consumer, Context, ChoreographerAssetsContextProvider as Provider };
